export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageForm.vue?vue&type=template&id=b38034aa&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/PageForm.vue?vue&type=template&id=b38034aa&
// module id = 1061
// module chunks = 0